import type { PropertyConfigCode } from "@/features/sub-families/types";

export const EXTERNAL_POWER = "EP" as PropertyConfigCode;
